/* Nordic Floor — filterskinnen på kolleksjonssiden (Fase B, T12).
   Filtreringen går gjennom Shopifys filter-URLer: skjemaet serialiseres
   til querystring, seksjonen hentes på nytt med section_id, og regionene
   merket data-nf-f-region byttes ut. Tilstanden ligger i URL-en, så
   visninger kan deles og tilbakeknappen virker (popstate). */
(function () {
  'use strict';

  function init(form) {
    if (!form || form.dataset.nfInit) return;
    form.dataset.nfInit = '1';

    var sectionId = form.dataset.sectionId;
    var sortDefault = form.dataset.sortDefault || 'manual';
    var sortSelect = form.querySelector('[data-nf-f-sort]');
    /* Sorteringer som gjøres i nettleseren, ikke av Shopify. Samlesiden
       har bare «Pris per m²»; søkesiden legger til «Serie, så navn A–Å»
       via data-nf-klientsort, fordi /search følger bare relevance og
       price-* på serveren (målt 27. september). data-nf-hentsort sier at
       sidene HENTES med en serversortering når det sorteres i nettleseren.
       Fra E5 (28. september) hentes de i begge prisretningene, stigende og
       synkende, og slås sammen: Shopify holder ikke fast rekkefølge mellom
       like priser, se renderKlientSoek. Uten attributtene er alt som før:
       bare m2, hentet som i dag (samlesiden). */
    var M2_SORT = 'm2-ascending';
    var TITTEL_SORT = 'title-ascending';
    var klientSorter = (form.dataset.nfKlientsort || M2_SORT).split(',');
    var hentSort = form.dataset.nfHentsort || '';
    var kontroller = null;
    var debounceT = null;
    /* Sist rendrede querystring — vakt mot unødig refetch på popstate
       som ikke gjelder oss (hash-navigering, andre pushState-kilder). */
    var sisteQs = window.location.search.replace(/^\?/, '');

    /* En sort_by-verdi fra URL-en trenger ikke finnes blant valgene i
       velgeren — tre i begge: «Serie» på samlesiden, «Mest relevant» i
       stedet på søkesiden (kolleksjonens admin-sortering kan være en helt
       annen).
       Settes den likevel, blanker nettleseren hele <select>-en. */
    function settSort(verdi) {
      if (!sortSelect) return;
      var finnes = false;
      for (var i = 0; i < sortSelect.options.length; i++) {
        if (sortSelect.options[i].value === verdi) {
          finnes = true;
          break;
        }
      }
      sortSelect.value = finnes ? verdi : sortSelect.options[0].value;
    }

    function params() {
      var fd = new FormData(form);
      var p = new URLSearchParams();
      fd.forEach(function (v, k) {
        if (v !== '') p.append(k, v);
      });
      if (sortSelect && sortSelect.value !== sortDefault) {
        p.set('sort_by', sortSelect.value);
      }
      return p.toString();
    }

    /* ?section_id-svaret har ingen <head>, så tittelen kan ikke leses ut av
       det. Seksjonen sender den i stedet som data-nf-doktittel på sidehodet,
       og den følger med når regionen byttes. Uten dette ble tittelen stående
       på «Alle gulv» gjennom hele filtreringen — også i historikken og i et
       bokmerke tatt underveis. */
    function settDokumenttittel() {
      var hode = document.getElementById('NfSidehode');
      if (!hode) return;
      var t = hode.getAttribute('data-nf-doktittel');
      if (t) document.title = t;
    }

    /* Etter en swap er det utløsende elementet ofte borte — en chip og
       «Nullstill» forsvinner nettopp fordi de ble klikket. Uten dette
       faller tastaturfokus til <body> og brukeren mister plassen sin. */
    function gjenopprettFokus(aktivId, fokusVarInne) {
      var igjen = aktivId ? document.getElementById(aktivId) : null;
      if (igjen) {
        igjen.focus();
        return;
      }
      if (!fokusVarInne || document.activeElement !== document.body) return;
      /* Søkesiden har ingen skinne. Der lander fokus på resultatene etter
         «Prøv igjen» (E3), i stedet for å falle til <body>. */
      var anker = document.getElementById('NfSkinneTopp') || document.getElementById('NfSkinne') || document.getElementById('ProductGridContainer');
      if (!anker) return;
      anker.setAttribute('tabindex', '-1');
      anker.focus();
    }

    /* «Pris per m²» er ikke en Shopify-sortering.
       ======================================================================
       Shopifys sort_by godtar åtte faste nøkler, og ingen av dem er et
       metafelt. price-ascending sorterer på PAKKEPRIS, og siden
       m2_per_pakke varierer mellom seriene er de to rekkefølgene delvis
       motsatte: Amaron Wood har høyest pakkepris av de tre store seriene
       og lavest kvadratmeterpris, fordi pakken er større.

       Verdien bæres likevel i sort_by. Målt at collection.sort_by ekko-er
       tilbake også ukjente verdier, så seksjonen kan velge riktig
       <option> etter en full sidelasting — en delt lenke overlever.
       Shopify sorterer da på kolleksjonens standard, og JS-en her sorterer
       om.

       Hele settet hentes, ikke bare siden man står på. Å stokke om de 36
       kortene som allerede ligger i DOM-en ville gitt en pen stigende
       rekke på side 1 og begynt på nytt lavere på side 2 — feil for
       kunden, og verre enn i dag fordi det SER riktig ut. */
    function hentDok(url, sig) {
      return fetch(url, sig).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
    }

    function byttRegioner(doc) {
      document.querySelectorAll('[data-nf-f-region]').forEach(function (region) {
        var kilde = doc.getElementById(region.id);
        if (!kilde) return;
        region.innerHTML = kilde.innerHTML;
        /* Regionsnodene blir stående; bare innholdet byttes. Data som
           ligger PÅ noden må derfor kopieres for seg — ellers ville
           dokumenttittelen aldri endret seg. */
        var t = kilde.getAttribute('data-nf-doktittel');
        if (t !== null) region.setAttribute('data-nf-doktittel', t);
      });
    }

    /* E3 (27. september): Shopifys søk feiler av og til — på 10–25 % av
       søkene mot dev-serveren, og også i kundetempo. Svaret er HTTP 200, men
       søkeobjektet feiler inne i Liquid, og seksjonen kommer uten rutenett.
       Et slikt svar er et feilet svar, ikke et tomt søk:
         · søkemalen merker selv et feilet søk med data-nf-soekfeil
         · søkesidens skjema har data-nf-krev-grid: der har et gyldig svar
           ALLTID rutenett, for skjemaet finnes bare når søket ga treff.
           Samlesiden har det ikke — der betyr et svar uten rutenett «ingen
           gulv passer filtrene» (.nf-f-tom), og det er et riktig svar.
       Før E3 ga et feilet svar null kort, og rutenettet ble tømt. */
    var krevGrid = form.hasAttribute('data-nf-krev-grid');
    var hvem = krevGrid ? 'Søket' : 'Butikken';
    function feiletSvar(doc) {
      if (!doc) return true;
      if (doc.querySelector('[data-nf-soekfeil]')) return true;
      /* Et gyldig seksjonssvar har alltid rutenettområdet — samlesiden
         ubetinget, søkesiden når søket ga treff. Mangler det, er svaret
         noe annet (passordsiden, en mellomside), og det skal ikke tømme
         lista. */
      if (!doc.getElementById('ProductGridContainer')) return true;
      return krevGrid && !doc.getElementById('product-grid');
    }

    /* En side etter siste treff: søkemalen merker den data-nf-tom-side når
       antallet ble lest, men siden var tom. Før E1 skjedde det når
       søkeindeksen flyttet seg mellom to forespørsler; fra E1 (250 per side)
       er det i praksis gamle adresser med page=2 og videre, og kunden får
       der en lenke til første side. Et søk uten treff har bare det skjulte
       merket. Den er gyldig og tom, ikke feilet. */
    function tomSide(doc) {
      return !!(doc && doc.querySelector('[data-nf-tom-side]') && !doc.querySelector('[data-nf-soekfeil]'));
    }

    /* «side 2», «sidene 2 og 3», «sidene 2, 3 og 4» */
    function sideliste(n) {
      if (n.length === 1) return 'side ' + n[0];
      return 'sidene ' + n.slice(0, -1).join(', ') + ' og ' + n[n.length - 1];
    }

    /* ETT AUTOMATISK NYTT FORSØK (Selams klarsignal 28. september, etter at
       årsaken var rapportert). Svarer Shopify med søkefeilen, hentes samme
       side én gang til etter et kort opphold, før meldingen vises. Bare én
       gang, og bare for søkefeilen: et svar med søkemalens merke, eller et
       søkesvar uten rutenett. HTTP-feil og nettverksfeil får ikke nytt
       forsøk. Målt 27. september i kundetempo: 8 av 144 forespørsler feilet,
       og bare én gang kom to feil etter hverandre (med ti sekunders
       mellomrom). Et nytt forsøk fanger altså de fleste.
       Hovedsøket har sitt eget forsøk i søkemalen (data-nf-nytt-forsoek). */
    var NYTT_FORSOEK_MS = 1000;
    var ANTALL_NYE_FORSOEK = 1;
    function erSoekefeil(doc) {
      if (!doc) return false;
      if (doc.querySelector('[data-nf-soekfeil]')) return true;
      return krevGrid && !doc.getElementById('product-grid') && !tomSide(doc);
    }
    function avbrudd() {
      var e = new Error('avbrutt');
      e.name = 'AbortError';
      return e;
    }
    function vent(ms, sig) {
      return new Promise(function (ok, nei) {
        var signal = sig && sig.signal;
        if (signal && signal.aborted) {
          nei(avbrudd());
          return;
        }
        var t = window.setTimeout(ok, ms);
        if (signal) {
          signal.addEventListener('abort', function () {
            window.clearTimeout(t);
            nei(avbrudd());
          }, { once: true });
        }
      });
    }
    function hentSoek(url, sig, igjen) {
      if (igjen === undefined) igjen = ANTALL_NYE_FORSOEK;
      return hentDok(url, sig).then(function (doc) {
        if (igjen < 1 || !erSoekefeil(doc)) return doc;
        return vent(NYTT_FORSOEK_MS, sig).then(function () { return hentSoek(url, sig, igjen - 1); });
      });
    }

    /* En side som ikke kom — HTTP-feil eller nettverk — teller som et
       feilet svar. Avbrudd (et nytt valg overtok) sendes videre. Samme
       forespørsel som før, pluss det ene nye forsøket ved søkefeilen. */
    function hentEllerNull(url, sig) {
      return hentSoek(url, sig).catch(function (feil) {
        if (feil && feil.name === 'AbortError') throw feil;
        return null;
      });
    }

    /* Meldingen står over rutenettet, utenfor regionen som byttes, så den
       overlever et bytte, og den forsvinner ved neste visning som gikk bra.
       Den vises først når også det ene automatiske nye forsøket (hentSoek)
       har feilet. «Prøv igjen» kjører samme henting på nytt når kunden ber
       om det, og den får igjen det ene nye forsøket, ikke flere. */
    function visMelding(tekst, qs) {
      var boks = document.getElementById('NfFMelding');
      if (!boks) {
        var region = document.getElementById('ProductGridContainer');
        if (!region || !region.parentNode) return;
        boks = document.createElement('div');
        boks.id = 'NfFMelding';
        boks.className = 'nf-f-melding';
        boks.setAttribute('role', 'alert');
        region.parentNode.insertBefore(boks, region);
      }
      boks.innerHTML = '';
      var p = document.createElement('p');
      p.textContent = tekst;
      var knapp = document.createElement('button');
      knapp.type = 'button';
      /* --lenke: .nf-knapp alene har flex: 1 1 auto og ville strukket seg
         over hele raden. Fast id, så fokus finner tilbake til knappen hvis
         nytt forsøk også feiler. */
      knapp.id = 'NfFMeldingKnapp';
      knapp.className = 'nf-knapp nf-knapp--lenke';
      knapp.textContent = 'Prøv igjen';
      knapp.addEventListener('click', function () {
        /* Velgeren skal vise det som prøves igjen, som ved chips og
           tilbakeknappen. */
        settSort(new URLSearchParams(qs).get('sort_by') || sortDefault);
        render(qs, false);
      });
      boks.appendChild(p);
      boks.appendChild(knapp);
      boks.hidden = false;
    }

    function skjulMelding() {
      var boks = document.getElementById('NfFMelding');
      if (boks) {
        boks.hidden = true;
        boks.innerHTML = '';
      }
    }

    function tall(el, navn) {
      var v = parseFloat(el.getAttribute(navn));
      return isFinite(v) ? v : 0;
    }

    /* Sorteringsnøkkelen, i tre trinn:
         1. kr/m² stigende
         2. pakkepris stigende — hele serier har samme kr/m², og uten
            en andrenøkkel ville de stokket seg mellom lastinger
         3. serverens egen rekkefølge, som er stabil for en gitt sort_by
       Kort uten m2_per_pakke (pris_m2 = 0) sorteres ikke i det hele tatt.
       De beholder serverens rekkefølge og legges sist, slik at en
       pakkepris aldri havner blant kvadratmeterprisene. */
    function sorterM2(rader) {
      rader.forEach(function (r, i) { r.i = i; });
      rader.sort(function (a, b) {
        if (!a.m2 && !b.m2) return a.i - b.i;
        if (!a.m2) return 1;
        if (!b.m2) return -1;
        if (a.m2 !== b.m2) return a.m2 - b.m2;
        if (a.pk !== b.pk) return a.pk - b.pk;
        return a.i - b.i;
      });
      return rader;
    }

    /* «Serie, så navn A–Å» i nettleseren: hele produkttittelen
       («Serie – Dekor», data-nf-tittel på kortet), sammenlignet på
       KODEPUNKT — det er det Shopifys title-ascending gjør. Målt
       27. september på samlesiden, 80 av 80 kort: Shopify legger «Woodric
       Acoustic Aculay – …» FØR «Woodric – …» (mellomrom U+0020 kommer før
       tankestrek U+2013), mens localeCompare('nb') ville lagt dem motsatt.
       Samme etikett skal gi samme rekkefølge på begge sidene. Kort uten
       tittel (artikler og sider på søkesiden) legges sist i serverens
       rekkefølge — samme prinsipp som kort uten m² over. */
    function sorterTittel(rader) {
      rader.forEach(function (r, i) { r.i = i; });
      rader.sort(function (a, b) {
        if (!a.tittel && !b.tittel) return a.i - b.i;
        if (!a.tittel) return 1;
        if (!b.tittel) return -1;
        if (a.tittel < b.tittel) return -1;
        if (a.tittel > b.tittel) return 1;
        return a.i - b.i;
      });
      return rader;
    }

    function samleKort(doc) {
      var ut = [];
      doc.querySelectorAll('#product-grid > li').forEach(function (li) {
        var a = li.querySelector('a.nf-dekor');
        var lenke = li.querySelector('a[href]');
        ut.push({
          li: li,
          href: a ? (a.getAttribute('href') || '') : '',
          id: a ? (a.getAttribute('data-nf-id') || '') : '',
          lenke: lenke ? (lenke.getAttribute('href') || '') : '',
          tekst: li.textContent.replace(/\s+/g, ' ').trim().slice(0, 200),
          m2: a ? tall(a, 'data-nf-m2pris') : 0,
          pk: a ? tall(a, 'data-nf-pakkepris') : 0,
          tittel: a ? (a.getAttribute('data-nf-tittel') || '') : ''
        });
      });
      return ut;
    }

    /* Nøkkelen et kort er «det samme» på: produktets ID, ellers lenken uten
       spørrestreng (søkets lenker bærer ?_pos=N, og _pos er plassen i
       treffet), ellers teksten. Sider og artikler i søket har ingen ID,
       men en lenke. Et kort uten nøkkel ville blitt talt én gang per
       retning, og antallet ville sett komplett ut før det var det. */
    function noekkel(r) {
      if (r.id) return 'id:' + r.id;
      var l = (r.href || r.lenke || '').split('?')[0];
      if (l) return 'l:' + l;
      return r.tekst ? 't:' + r.tekst : '';
    }

    function renderKlient(qs, sortNaa, push, grid, sig, ferdig) {
      /* Samlesiden. Sidene hentes med qs slik den er: serveren ignorerer
         m2-ascending og gir kolleksjonens rekkefølge, som er fast.
         Søkesiden går gjennom renderKlientSoek under. */
      var base = window.location.pathname + '?section_id=' + sectionId + (qs ? '&' + qs : '');
      return hentEllerNull(base, sig).then(function (doc1) {
        /* E3: side 1 kom ikke. Da kom ingen treff — lista står slik den
           var, aldri tom, og kunden får vite hvorfor. */
        if (feiletSvar(doc1)) {
          ferdig(hvem + ' svarte ikke. Lista står slik den var.');
          return;
        }
        var ul = doc1.getElementById('product-grid');
        var antall = ul ? parseInt(ul.getAttribute('data-nf-antall'), 10) : 0;
        var perSide = ul ? parseInt(ul.getAttribute('data-nf-per-side'), 10) : 0;
        /* Taket på 10 er en brems, ikke en grense vi venter å treffe:
           92 gulv på 36 per side er 3 sider. */
        var sider = (antall > 0 && perSide > 0) ? Math.min(10, Math.ceil(antall / perSide)) : 1;
        var resten = [];
        for (var s = 2; s <= sider; s += 1) resten.push(hentEllerNull(base + '&page=' + s, sig));
        return Promise.all(resten).then(function (docs) {
          byttRegioner(doc1);
          var rader = samleKort(doc1);
          /* E3: en side som ikke kom, hoppes over og noteres. */
          var mangler = [];
          docs.forEach(function (d, i) {
            if (tomSide(d)) return;
            if (feiletSvar(d)) {
              mangler.push(i + 2);
              return;
            }
            rader = rader.concat(samleKort(d));
          });
          /* Sidene hentes parallelt fra en indeks som kan flytte seg mellom
             to forespørsler (søket, målt 27. september). Et kort som krysser
             en sidegrense i mellomtiden ville ellers stått to ganger. Første
             forekomst vinner; kort uten lenke (artikler) røres ikke.
             Nøkkelen er stien uten spørrestreng (27. september, E3): søkets
             lenker bærer ?_pos=N&_sid=…, og _pos er plassen i treffet, så
             samme gulv på to sider hadde to ulike lenker og ble aldri luket. */
          var sett = {};
          rader = rader.filter(function (r) {
            if (!r.href) return true;
            var noekkel = r.href.split('?')[0];
            if (sett[noekkel]) return false;
            sett[noekkel] = true;
            return true;
          });
          /* E3: mangler en side, sorteres ingenting. En sortert rekke med et
             hull ser komplett ut, og kunden ville trodd at det billigste
             gulvet sto øverst. Kunden får det som kom, i den rekkefølgen
             Shopify ga det — Selams krav — og meldingen sier hva som mangler. */
          if (!mangler.length) {
            if (sortNaa === TITTEL_SORT) { sorterTittel(rader); } else { sorterM2(rader); }
          }
          var maal = document.getElementById('product-grid');
          if (maal) {
            maal.innerHTML = '';
            rader.forEach(function (r) { maal.appendChild(document.importNode(r.li, true)); });
          }
          /* Alt ligger på én side nå, så serverens paginering ville løyet. */
          var pag = document.querySelector('#ProductGridContainer .pagination-wrapper');
          if (pag && pag.parentNode) pag.parentNode.removeChild(pag);
          ferdig(mangler.length
            ? hvem + ' svarte ikke på ' + sideliste(mangler) + ' av ' + sider + '. Viser ' + rader.length + ' av ' + antall + (krevGrid ? ' treff' : ' gulv') + ' i den rekkefølgen de kom, ikke sortert.'
            : null);
        });
      });
    }

    /* E1 (29. september): søkemalen viser 250 per side, så et vanlig søk har
       én side, og under henter sorteringen bare side 1 stigende og synkende.
       Flersidestiene under gjelder først når et søk gir mer enn 250 treff.
       De prøves på kunstige sider i test-soekfeil.js og i jsdom
       (test-filter.js).

       E5 (28. september): søkesidens sortering henter sidene i BEGGE
       prisretninger. Shopify holder ikke fast rekkefølge mellom treff med
       samme pakkepris fra én forespørsel til den neste. Målt på «plank»,
       der alle 17 Woodric-gulv koster 894 kr: Rockford Oak sto på to sider
       og Timbersland Oak på ingen, 58 treff og 57 ulike. Et gulv som faller
       mellom to sider den ene veien, ligger som regel på en side den andre
       veien — men ikke alltid: på «plank» ligger begge sidegrensene inne i
       gruppen på 894 kr (stigende plass 29–51), så det kan falle mellom
       sidene begge veier. Det er derfor regel 2 og 3 finnes.
       Selams regler:
         1. hent stigende og synkende, slå sammen, fjern dubletter på
            produkt-ID
         2. kontroller mot antallet søket selv oppgir; mangler noe, én runde
            til
         3. mangler det fortsatt noe, vis Shopifys egen rekkefølge med vanlig
            sideinndeling, uten melding. Kunden skal aldri få en sortert
            liste som mangler et gulv.
       Svarer ikke Shopify på den siste hentingen heller, gjelder E3: lista
       står slik den var, med melding. Hver side har fortsatt sitt ene nye
       forsøk ved søkefeilen (hentSoek). */
    var RETNINGER = ['price-ascending', 'price-descending'];

    function hentRetning(qs, retning, sig) {
      var ph = new URLSearchParams(qs);
      ph.set('sort_by', retning);
      var base = window.location.pathname + '?section_id=' + sectionId + '&' + ph.toString();
      return hentEllerNull(base, sig).then(function (doc1) {
        if (feiletSvar(doc1)) return { doc1: null, rader: [], antall: 0 };
        var ul = doc1.getElementById('product-grid');
        var antall = ul ? parseInt(ul.getAttribute('data-nf-antall'), 10) : 0;
        var perSide = ul ? parseInt(ul.getAttribute('data-nf-per-side'), 10) : 0;
        /* Taket på 10 er en brems, som på samlesiden. */
        var sider = (antall > 0 && perSide > 0) ? Math.min(10, Math.ceil(antall / perSide)) : 1;
        var resten = [];
        for (var s = 2; s <= sider; s += 1) resten.push(hentEllerNull(base + '&page=' + s, sig));
        return Promise.all(resten).then(function (docs) {
          var rader = samleKort(doc1);
          docs.forEach(function (d) {
            if (tomSide(d) || feiletSvar(d)) return;
            rader = rader.concat(samleKort(d));
          });
          return { doc1: doc1, rader: rader, antall: isFinite(antall) ? antall : 0 };
        });
      });
    }

    function hentBegge(qs, sig) {
      return Promise.all(RETNINGER.map(function (r) { return hentRetning(qs, r, sig); }));
    }

    /* Regel 3: Shopifys egen rekkefølge for søket, med sideinndelingen
       Shopify tegner, og velgeren tilbake på «Mest relevant» — lista er
       ikke sortert, og velgeren skal ikke si at den er det. Adressen
       følger, uten sort_by. */
    function tilbakefall(qs, sig, ferdig) {
      var p = new URLSearchParams(qs);
      p.delete('sort_by');
      var qsShopify = p.toString();
      /* hentEllerNull, ikke hentSoek: også en HTTP- eller nettverksfeil skal
         ende i E3-meldingen, ikke i en full omlasting. Det ene nye forsøket
         ved søkefeilen følger med. */
      return hentEllerNull(window.location.pathname + '?section_id=' + sectionId + (qsShopify ? '&' + qsShopify : ''), sig)
        .then(function (doc) {
          if (feiletSvar(doc)) {
            ferdig(hvem + ' svarte ikke. Lista står slik den var.');
            return;
          }
          byttRegioner(doc);
          settSort(sortDefault);
          ferdig(null, qsShopify);
        });
    }

    function renderKlientSoek(qs, sortNaa, sig, ferdig) {
      var sett = {};
      var rekke = [];
      var antall = 0;
      var doc1 = null;
      function legg(runde) {
        runde.forEach(function (res) {
          if (!doc1 && res.doc1) doc1 = res.doc1;
          if (res.antall > antall) antall = res.antall;
          res.rader.forEach(function (r) {
            var k = noekkel(r);
            if (k && sett[k]) return;
            if (k) sett[k] = true;
            rekke.push(r);
          });
        });
      }
      function komplett() { return !!doc1 && antall > 0 && rekke.length >= antall; }
      return hentBegge(qs, sig).then(function (runde1) {
        legg(runde1);
        if (komplett()) return true;
        return hentBegge(qs, sig).then(function (runde2) {
          legg(runde2);
          return komplett();
        });
      }).then(function (ok) {
        if (!ok) return tilbakefall(qs, sig, ferdig);
        byttRegioner(doc1);
        /* Fast grunnrekkefølge før sorteringen: tittel, så ID. Rekkefølgen
           Shopify ga, er nettopp det som ikke er fast mellom forespørsler,
           og den avgjorde før rekkefølgen mellom gulv med lik pris. */
        rekke.sort(function (a, b) {
          if (a.tittel !== b.tittel) return a.tittel < b.tittel ? -1 : 1;
          if (a.id !== b.id) return a.id < b.id ? -1 : 1;
          return 0;
        });
        if (sortNaa === TITTEL_SORT) { sorterTittel(rekke); } else { sorterM2(rekke); }
        var maal = document.getElementById('product-grid');
        if (maal) {
          maal.innerHTML = '';
          rekke.forEach(function (r) { maal.appendChild(document.importNode(r.li, true)); });
        }
        /* Alt ligger på én side nå, så serverens paginering ville løyet. */
        var pag = document.querySelector('#ProductGridContainer .pagination-wrapper');
        if (pag && pag.parentNode) pag.parentNode.removeChild(pag);
        ferdig(null);
      });
    }

    function render(qs, push, erOppstart) {
      if (kontroller) kontroller.abort();
      kontroller = 'AbortController' in window ? new AbortController() : null;
      var grid = document.getElementById('ProductGridContainer');
      if (grid) grid.classList.add('nf-f-laster');
      var sig = kontroller ? { signal: kontroller.signal } : undefined;
      var aktivId = document.activeElement ? document.activeElement.id : '';
      var fokusVarInne = form.contains(document.activeElement);
      /* E3: en melding fra et tidligere forsøk tas bort når en ny visning
         starter, så en gammel «Prøv igjen» ikke kan avbryte den nye. */
      skjulMelding();

      /* meldingTekst er satt når noe ikke kom (E3); ellers skjules en
         melding fra et tidligere forsøk. nyQs er satt når det som vises,
         ikke er det kunden valgte (E5, regel 3: Shopifys egen rekkefølge i
         stedet for en sortering som manglet treff). Da følger adressen det
         som vises — pushet ved et valg, byttet ut ved oppstart. */
      function ferdig(meldingTekst, nyQs) {
        var q = nyQs === undefined ? qs : nyQs;
        if (grid) grid.classList.remove('nf-f-laster');
        if (meldingTekst) { visMelding(meldingTekst, q); } else { skjulMelding(); }
        gjenopprettFokus(aktivId, fokusVarInne);
        settDokumenttittel();
        sisteQs = q;
        var ny = window.location.pathname + (q ? '?' + q : '');
        /* Viser vi Shopifys rekkefølge for nøyaktig den adressen kunden
           står på (hun kom fra «Mest relevant»), ville en ny oppføring gitt
           to like etter hverandre, og første trykk på Tilbake gjort ingenting. */
        var samme = function () {
          var a = new URLSearchParams(q); a.sort();
          var b = new URLSearchParams(window.location.search); b.sort();
          return a.toString() === b.toString();
        };
        if (push && !(nyQs !== undefined && samme())) {
          window.history.pushState({ nfFilter: q }, '', ny);
        } else if (nyQs !== undefined) {
          window.history.replaceState({ nfFilter: q }, '', ny);
        }
        document.dispatchEvent(new CustomEvent('nf:filter:oppdatert', { detail: { melding: meldingTekst || null, shopifysRekkefoelge: nyQs !== undefined } }));
      }

      var sortNaa = new URLSearchParams(qs).get('sort_by');
      var erKlient = klientSorter.indexOf(sortNaa) >= 0;
      var jobb = erKlient
        ? (hentSort ? renderKlientSoek(qs, sortNaa, sig, ferdig) : renderKlient(qs, sortNaa, push, grid, sig, ferdig))
        : hentSoek(window.location.pathname + '?section_id=' + sectionId + (qs ? '&' + qs : ''), sig)
          .then(function (doc) {
            /* E3: et feilet søkesvar byttes ikke inn — da ville lista stått
               tom. Den står slik den var, med melding. */
            if (feiletSvar(doc)) {
              ferdig(hvem + ' svarte ikke. Lista står slik den var.');
              return;
            }
            byttRegioner(doc);
            ferdig();
          });

      jobb.catch(function (feil) {
        if (feil && feil.name === 'AbortError') return;
        /* Ved oppstart har serveren alt tegnet rutenettet; bare rekkefølgen
           mangler. En omlasting kan ikke reparere det — den ville kjørt
           oppstarten om igjen og lukket en evig sløyfe ved vedvarende feil
           (429 etter N parallelle sidehentinger, 5xx). Da blir serverens
           rekkefølge stående, og laste-klassen tas av. */
        if (erOppstart) {
          if (grid) grid.classList.remove('nf-f-laster');
          return;
        }
        /* Nettverksfeil: fall tilbake på full sidelast med samme URL */
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); });

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="checkbox"]')) return;
      window.clearTimeout(debounceT);
      debounceT = window.setTimeout(function () {
        render(params(), true);
      }, 150);
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        render(params(), true);
      });
    }

    /* Chips og «Nullstill» er lenker — samme mekanikk, URL-en er fasit */
    form.addEventListener('click', function (e) {
      var lenke = e.target.closest ? e.target.closest('[data-nf-f-lenke]') : null;
      if (!lenke) return;
      e.preventDefault();
      var u = new URL(lenke.href, window.location.origin);
      settSort(u.searchParams.get('sort_by') || sortDefault);
      render(u.searchParams.toString(), true);
    });

    window.addEventListener('popstate', function () {
      var qs = window.location.search.replace(/^\?/, '');
      if (qs === sisteQs) return;
      settSort(new URLSearchParams(qs).get('sort_by') || sortDefault);
      render(qs, false);
    });

    /* Ved full sidelasting med «Pris per m²» valgt har serveren rendret i
       sin egen rekkefølge — Shopify kan ikke sortere på metafeltet. Uten
       denne ville en delt lenke eller et trykk på oppdater vist feil
       rekkefølge under riktig etikett, som er verre enn ingen sortering.
       push er false: URL-en er allerede riktig. */
    /* Søkesiden: search.sort_by ekko-er IKKE ukjente verdier (målt
       27. september — ?sort_by=m2-ascending rendres med «Mest relevant»
       valgt), så en delt lenke ville mistet valget sitt. URL-en er fasit:
       står det et klientvalg der som velgeren ikke viser, settes det her.
       Samlesiden er upåvirket — collection.sort_by ekko-er, så velgeren
       stemmer alt. */
    var urlSort = new URLSearchParams(window.location.search).get('sort_by');
    if (urlSort && sortSelect && sortSelect.value !== urlSort) {
      settSort(urlSort);
      if (sortSelect.value !== urlSort) {
        /* En verdi velgeren ikke har — price-ascending fra en gammel lenke,
           som serveren fortsatt følger: lista er prissortert, men velgeren
           kan ikke vise det, og etiketten ville løyet over lista. URL-en
           renses for sort_by, og siden hentes i standard rekkefølge — uten
           omlasting. Gjelder begge sidene. */
        var up = new URLSearchParams(window.location.search);
        up.delete('sort_by');
        var ren = up.toString();
        window.history.replaceState({ nfFilter: ren }, '', window.location.pathname + (ren ? '?' + ren : ''));
        sisteQs = ren;
        render(params(), false, true);
      }
    }
    if (sortSelect && klientSorter.indexOf(sortSelect.value) >= 0) {
      render(params(), false, true);
    }

    /* ---------- Mobilskuffen ---------- */
    var skinne = document.getElementById('NfSkinne');
    var aapneKnapp = form.querySelector('[data-nf-f-aapne]');
    if (!skinne) return;

    function erAapen() { return skinne.classList.contains('apen'); }

    function aapne() {
      skinne.classList.add('apen');
      document.documentElement.classList.add('nf-f-laast');
      if (aapneKnapp) aapneKnapp.setAttribute('aria-expanded', 'true');
      /* M6: fokus skal aldri havne på noe usynlig.
         querySelector traff den FØRSTE fokuserbare i skinnen, og det er
         avkryssingsboksen — opacity: 0, width: 0, height: 0. Et
         programmatisk .focus() utløser normalt ikke :focus-visible i
         Chrome, så markøren forsvant helt: brukeren sto i en skuff uten
         å se hvor.

         Skuffen selv tar fokus, som i et dialogmønster, og leser opp
         aria-label «Filtrer gulv». Fallbacken velger første fokuserbare
         MED en boks, i tilfelle tabindex skulle mangle i markup. */
      if (skinne.hasAttribute('tabindex') && typeof skinne.focus === 'function') {
        skinne.focus();
      } else {
        var kand = skinne.querySelectorAll('input, button, a[href], select');
        for (var i = 0; i < kand.length; i += 1) {
          var r = kand[i].getBoundingClientRect();
          if (r.width > 0 && r.height > 0) { kand[i].focus(); break; }
        }
      }
    }

    function lukk() {
      skinne.classList.remove('apen');
      document.documentElement.classList.remove('nf-f-laast');
      if (aapneKnapp) {
        aapneKnapp.setAttribute('aria-expanded', 'false');
        /* Alltid tilbake til knappen — et museklikk fokuserer den ikke i
           alle nettlesere, så «forrige fokus» er ikke til å stole på. */
        aapneKnapp.focus();
      }
    }

    if (aapneKnapp) {
      aapneKnapp.addEventListener('click', function () {
        if (erAapen()) { lukk(); } else { aapne(); }
      });
    }

    skinne.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-nf-f-lukk]')) lukk();
    });

    document.addEventListener('keydown', function (e) {
      if (!erAapen()) return;
      if (e.key === 'Escape') {
        lukk();
        return;
      }
      if (e.key !== 'Tab') return;
      /* Enkel fokusfelle: Tab sirkulerer innenfor skuffen */
      var fokuserbare = skinne.querySelectorAll('input, button, a[href], select');
      if (!fokuserbare.length) return;
      var foerste = fokuserbare[0];
      var siste = fokuserbare[fokuserbare.length - 1];
      if (e.shiftKey && document.activeElement === foerste) {
        siste.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === siste) {
        foerste.focus();
        e.preventDefault();
      }
    });
  }

  function boot(rot) {
    Array.prototype.forEach.call(
      (rot || document).querySelectorAll('[data-nf-f-form]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme-editoren bytter ut seksjonens DOM ved re-render; init på nytt. */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });

  /* Søkemalens nye forsøk (E3) bytter inn søkeseksjonen når hovedsøket
     svarte andre gang. Skjemaet er da nytt og må få sin init. */
  document.addEventListener('nf:seksjon:byttet', function () { boot(); });
})();
